import React from 'react'

import { Accordion, Box, Display, FlexDirection, Space } from '@gousto-internal/citrus-react'
import { useDispatch } from 'react-redux'

import { boxSizePriceBreakdownTracking } from 'actions/basket'

import { AccordionTitle, AccordionTableBody, AccordionTableHeader } from './Components'

type BoxSizePriceBreakdownAccordionProps = {
  boxSize: number
  setIsOpen: (value: boolean) => void
}

export const BoxSizePriceBreakdownAccordion = ({
  boxSize,
  setIsOpen,
}: BoxSizePriceBreakdownAccordionProps) => {
  const dispatch = useDispatch()

  const handleTrackingEvent = (value: boolean) => {
    setIsOpen(value)
    dispatch(boxSizePriceBreakdownTracking(boxSize, value))
  }

  return (
    <Accordion
      id={`price-breakdown-step-accordion-${boxSize}`}
      data-testid={`priceBreakdownStepAccordion${boxSize}`}
      title={AccordionTitle}
      onChange={(state) => handleTrackingEvent(state)}
    >
      <Box display={Display.Flex} flexDirection={FlexDirection.Column} paddingH={3}>
        <Space size={2} direction="vertical" />
        <AccordionTableHeader />
        <AccordionTableBody boxSize={boxSize} />
      </Box>
    </Accordion>
  )
}
